import { FeatureConfiguration } from "..";
import { Migration } from "./components/Migration";
import { reducer } from "./reducers";

export default function (config: FeatureConfiguration) {
    config.addRoutes(config.routes.locationRoutes, [<Migration key="migration" />]);

    config.reducers.migration = reducer;
}
